import React, { useState } from "react";

// import { connect } from "react-redux";
// import { createStructuredSelector } from "reselect";
import { Link } from "react-router-dom";
import Masonry from "react-masonry-css";

// import { selectAllLoads } from "../../redux/load/load.selectors";

import ReqCard from "../../containerSmall/ReqCard/ReqCard.component";

import { CardList } from "./ReqCardsList.styles";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  selectAllReqsPage,
  selectMyReqsPage,
  selectReqsActiveTab,
  selectAllReqsIsLoading,
  selectMyReqsIsLoading,
} from "../../redux/reqs/reqs.selectors";
import {
  fetchAllReqsAsync,
  fetchMyReqsAsync,
  setAllReqsPage,
  setMyReqsPage,
} from "../../redux/reqs/reqs.actions";
import socket from "../../assets/socketConnection";
import Spinner from "../../components/spinner/spinner.component";
import theme from "../../styledTheme/styledTheme";
import { removeFromString } from "../../utils/utils";
import useWindowSize from "../../hooks/useWindowSize";

const ReqCardsList = ({
  reqs,
  selectMyReqsPage,
  selectAllReqsPage,
  setAllReqsPage,
  selectReqsActiveTab,
  fetchAllReqsAsync,
  fetchMyReqsAsync,
  setMyReqsPage,
  selectAllReqsIsLoading,
  selectMyReqsIsLoading,
}) => {
  const [moreIsloading, setMoreIsloading] = useState(true);
  // const cardList = useRef(null);
  // const spinner = useRef(null);

  let [width] = useWindowSize();
  // console.log("width", width);
  // debugger;

  if (width === 0) return null;
  let responsiveCardNumbers =
    (width - 2 * Number(removeFromString(theme.fixedMenuWidth, "px"))) /
    Number(removeFromString(theme.fixedReqCardWidth, "px"));

  if (responsiveCardNumbers < 1) responsiveCardNumbers = 1;
  // console.log("sss", responsiveCardNumbers);

  // console.log(Math.floor(responsiveCardNumbers) - 1);
  const breakpointColumnsObj = {
    default: Math.floor(responsiveCardNumbers),

    // 2300: 6,
    // 1750: 5,
    // 1450: 4,
    // 1900: 3,
    // 1600: 2,
    // 1300: 1,
    // 600: 1,
  };

  const handle_cardList_scroll = (e) => {
    const scrollHeight = e.currentTarget.scrollHeight;
    const offsetHeight = e.currentTarget.offsetHeight;
    const scrollTop = e.currentTarget.scrollTop;

    const scrollBottom = scrollHeight - scrollTop - offsetHeight;

    // console.log("Height", e.currentTarget.height);
    // console.log("scrollHeight", scrollHeight);
    // console.log("scrollTop", scrollTop);

    if (scrollBottom < 100 && reqs.length % 30 === 0) {
      if (!selectMyReqsIsLoading && Number(selectReqsActiveTab) === 0) {
        setMyReqsPage(Number(selectMyReqsPage) + 1);
        fetchMyReqsAsync(socket);
        return;
      }
      if (!selectAllReqsIsLoading && Number(selectReqsActiveTab) === 1) {
        setAllReqsPage(Number(selectAllReqsPage) + 1);
        fetchAllReqsAsync(socket);
        return;
      }
    } else if (scrollBottom < 100) {
      // alert("hi");
      setMoreIsloading(false);
    }
  };
  // console.log("reqs.length", reqs);
  return (
    <CardList
      onScroll={handle_cardList_scroll}
      className="justify-content-center justify-content-md-between"
    >
      {/* {console.log(reqs[2].source_location._shahr)} */}
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {window.location.pathname.includes("without")?
          reqs?.map((item) => (
            <Link to={`/app2/without/${item.Custom_id}`} key={item.id}>
              <ReqCard reqInfo={item} />
            </Link>
          )):  reqs?.map((item) => (
            <Link to={`/app2/reqs/${item.Custom_id}`} key={item.id}>
              <ReqCard reqInfo={item} />
            </Link>
          ))
        }
      </Masonry>
      {/* {moreIsloading ? <Spinner style={{ height: "30vh" }} /> : ""} */}
    </CardList>
  );
};

const mapStateToProps = createStructuredSelector({
  selectMyReqsPage: selectMyReqsPage,
  selectAllReqsPage: selectAllReqsPage,
  selectReqsActiveTab: selectReqsActiveTab,
  selectAllReqsIsLoading: selectAllReqsIsLoading,
  selectMyReqsIsLoading: selectMyReqsIsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  fetchMyReqsAsync: (x) => dispatch(fetchMyReqsAsync(x)),
  fetchAllReqsAsync: (x) => dispatch(fetchAllReqsAsync(x)),
  setMyReqsPage: (page) => dispatch(setMyReqsPage(page)),
  setAllReqsPage: (page) => dispatch(setAllReqsPage(page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReqCardsList);
